module.exports = {
  metric: {
    single: {
      name: { singular: '', plural: '' },
      to_anchor: 1
    },
    hundreds: {
      name: { singular: 'Hundred', plural: 'Hundreds' },
      to_anchor: 100
    },
    thousands: {
      name: { singular: 'Thousand', plural: 'Thousands' },
      to_anchor: 1000
    },
    millions: {
      name: { singular: 'Million', plural: 'Millions' },
      to_anchor: 1000000
    },
    billions: {
      name: { singular: 'Billion', plural: 'Billions' },
      to_anchor: 1000000000
    }
  },
  imperial: {},
  _anchors: { metric: { unit: 'single', ratio: 1 } }
};

